import {
  getAllLots,
  getDryingBedInfo,
  getDryingLotsWithActiveBeds,
  getLotById,
  getStorageLotById,
  getStorageLots,
  getStorageConsumptions,
} from '@/network/api.service';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  lots: null,
  lot: null,
  dryingLots: [],
  selectedDryingBed: null,
  pagination: null,
  storageLots: [],
  storageDetailLots: [],
  storageConsumptions: [],
};

const actions = (set, get) => ({
  // SET estates after fetching
  setLots: lotList => set({ lots: lotList }),
  setLot: lot => set({ lot }),
  getLot: () => get().lot,

  getLotById: id => {
    const { lots } = get();
    return lots?.find(lot => lot.id === id);
  },
  updateLotById: (id, updater) => {
    // updater: object of fields to merge, or a function(currentLot) => nextLot
    set(state => ({
      lots: state.lots?.map(lot => {
        if (lot._id === id || lot.id === id) {
          const next = typeof updater === 'function' ? updater(lot) : updater;
          return { ...lot, ...next };
        }
        return lot;
      }),
    }));
  },
  getAllEstates: () => {
    return get().lots;
  },

  fetchLot: async (id, media = true) => {
    try {
      const { data } = await getLotById(id, media);
      set({ lot: data?.data });
    } catch (err) {
      console.error('fetchLot failed:', err);
      set({ lot: null });
    }
  },
  /* ------------------------
     DRYING LOTS
  ------------------------ */
  getDryingLots: () => get().dryingLots,

  fetchDryingLots: async (q, page = 1, limit = 20) => {
    try {
      const { data } = await getDryingLotsWithActiveBeds(q, page, limit);

      // set({ dryingLots: data?.data.data || [] });
      set(state => ({
        dryingLots: page === 1 ? data.data.data : [...state.dryingLots, ...data.data.data],
        pagination: data.data.pagination,
      }));
    } catch (err) {
      console.error('fetchDryingLots failed:', err);
      set({ dryingLots: [] });
    }
  },

  fetchDryingBedInfo: async dryingBedId => {
    try {
      const { data } = await getDryingBedInfo(dryingBedId);
      set({ selectedDryingBed: data?.data });
    } catch (error) {
      set({ selectedDryingBed: null });
    }
  },

  fetchPaginatedLots: async (q, page = 1, limit = 20) => {
    try {
      const { data } = await getAllLots({ search: q, page, limit });

      set(state => ({
        lots: page === 1 ? data.data.lots : [...state.lots, ...data.data.lots],
        pagination: data.data.pagination,
      }));
    } catch (err) {
      console.error('fetchPaginatedLots failed:', err);
      set({ lots: [] });
    }
  },

  /* ------------------------
     STORAGE LOTS
  ------------------------ */
  getStorageLots: () => get().storageLots,

  fetchStorageStageLots: async (q, page = 1, limit = 20) => {
    try {
      const { data } = await getStorageLots(q, page, limit);

      // set({ dryingLots: data?.data.data || [] });
      set(state => ({
        storageLots: page === 1 ? data.data.data : [...state.storageLots, ...data.data.data],
        pagination: data.data.pagination,
      }));
    } catch (err) {
      console.error('fetchStorageLots failed:', err);
      set({ storageLots: [] });
    }
  },

  // Fetches the storage lots of lot
  fetchStorageDetailLots: async id => {
    try {
      const { data } = await getStorageLotById(id);

      set({
        storageDetailLots: data?.data || [],
      });
    } catch (err) {
      console.error('fetchStorageDetailLots failed:', err);
      set({ storageDetailLots: [] });
    }
  },
  getStorageDetailLots: () => get().storageDetailLots,
  
  fetchStorageConsumptions: async id => {
    try {
      const { data } = await getStorageConsumptions(id);

      set({
        storageConsumptions: data?.data || [],
      });
    } catch (err) {
      console.error('fetchStorageConsumptions failed:', err);
      set({ storageConsumptions: [] });
    }
  },
  getStorageConsumptions: () => get().storageConsumptions,
});

export const useLotStore = create(
  devtools(
    (set, get) => ({
      ...initialState,
      ...actions(set, get),
    }),
    { name: 'LotStore' }
  )
);
